import styled from 'styled-components';
import { headerHeight } from 'styles/constants';

export const Container = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: `calc(100vh - ${headerHeight}px)`
}));